import classNames from 'classnames';
import {
	FirmwareAssignmentContext,
	IFirmwareAssignmentContext,
} from 'modules/FirmwareAndApp/Firmware/FirmwareAssignment/firmwareAssignmentState/firmwareAssignmentContext';
import React, { useContext, useEffect } from 'react';
import CustomerCrumb from './components/CustomerCrumb';
import RestaurantCrumb from './components/RestaurantCrumb';
import FirmwareCrumb from './components/FirmwareCrumb';
import style from './Breadcrumbs.module.scss';

const Breadcrumbs: React.FC = () => {
	const { setShowBreadcrumbs, isShowBreadcrumbs, IDsSelectedCustomers } =
		useContext<IFirmwareAssignmentContext>(FirmwareAssignmentContext);

	const containerClasses = classNames(style.container, { [style.hidden]: !isShowBreadcrumbs });

	const emptyCategories = !Object.keys(IDsSelectedCustomers).length;

	useEffect(() => {
		emptyCategories && setShowBreadcrumbs(false);
	}, [emptyCategories]);

	return (
		<div className={containerClasses} data-test="Breadcrumbs">
			<CustomerCrumb />
			<RestaurantCrumb />
			<FirmwareCrumb />
		</div>
	);
};

export default Breadcrumbs;
